import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';

// ActionCreators

import { changeData } from '@actions/ssap/ssapActionCreators';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

// Constants

import { DROPDOWN_OPTIONS, getOptionsForHardcodedState } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';



/**
 *
 * @param {Object} props
 * @returns {React.Component} - 'Additional Information - Member Enrolled In Other Health Insurance
 *
 */
const Page4_65 = props => {

    const {
        currentHhm,
        data,
        environment: {
            isState
        },
        formName,
        hhmIndex,
        householdMembers
    } = props;


    const {
        healthCoverage : {
            stateHealthBenefit
        },
        householdContact: {
            homeAddress: {
                state
            }
        },
        name
    } = currentHhm;

    const [ stateAbbr ] = state ? getOptionsForHardcodedState(state) : [{}];
    const onFieldChange = newData => {
        const newState = { ...data };
        newState.taxHousehold.householdMember[hhmIndex] = { ...newData };
        props.actions.changeData(newState);
    };

    return (
        <Fragment>
            <Form { ...{ formName } }>
                <div
                    className = 'fade-in'
                    id = 'aiStateHealthBenefit'
                >
                    <div className = 'subsection' >
                        <UniversalInput
                            legend = { {
                                dataInstructions: 'instructional_text.state_employee_health_benefit',
                                legendText: 'ssap.input.legend.state_health_benefit',
                                legendTextReplacements: {
                                    personName: (
                                        <strong>
                                            { normalizeNameOfPerson(name) }
                                        </strong>
                                    ),
                                    stateName: !isState.IL ? (
                                        <strong>{stateAbbr.text}</strong>
                                    ) : (
                                        stateAbbr.text
                                    ),
                                }
                            } }
                            label = { {
                                showRequiredIcon: true
                            } }
                            inputData = { {
                                isInputRequired: true,
                                type: INPUT_TYPES.RADIO_BUTTONS,
                                name: 'stateHealthBenefit',
                                value: stateHealthBenefit,
                                options: DROPDOWN_OPTIONS.YES_NO,
                                validationType: VALIDATION_TYPES.CHOSEN,
                                currentData: householdMembers[hhmIndex],
                                fields: [ 'healthCoverage' ],
                                isInputStandalone: true

                            } }
                            inputActions = { {
                                onFieldChange: onFieldChange
                            } }
                            errorClasses = { [ 'margin-l-0' ] }
                        />
                    </div>
                </div>
            </Form>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    environment: state.common.environment,
    household: state
        .ssap
        .data
        .taxHousehold,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember,

    page: state.ssap.page
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page4_65);
